import {createUseStyles} from "react-jss";
import {select} from "../../theme";

export const useStyles = createUseStyles({
    component: {
        display: "inline-block",
    },
    select: {
       ...select,
    }
});